<!-- 采购返利数据操作 -->
<template>
  <div>
    <div class="demo-drawer__content data_action_form">
      <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
        <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
          :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
          <template slot="tabs" slot-scope="scope">
            <div class="table_content_box">
              <!-- 主要信息 -->
              <div v-if="scope.index == 0">
                <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo"
                  size="mini" :show-message="false">
                  <el-row v-if="dataActionBox.actionType != 2">
                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                      v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                      :prop="formOneValue.entityField"
                      :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                      <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                        v-html="$common.htmlLabel(formOneValue.showField)"></label>
                      <!-- 日期 -->
                      <df-date class="form_codition" v-if="formOneValue.entityField == 'psomBuydate'"
                        v-model="sendDataInfo[formOneValue.entityField]" :isShowLong="false"
                        :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)">
                      </df-date>
                      <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false"
                        v-model="sendDataInfo[formOneValue.entityField]"
                        :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)">
                      </df-date>
                      <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                        <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]"
                          :ref="formOneValue.entityField" :id="formOneValue.entityField"
                          @keyup.enter.native="openExtSearch(formOneValue.extractId)"
                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)">
                          <el-button @click="openExtSearch(formOneValue.extractId)" slot="append" icon="el-icon-search"
                            :disabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0) || dataActionBox.actionType == 2">
                          </el-button>
                        </el-input>
                      </el-tooltip>
                      <!-- formatter下拉选   :automatic-dropdown="true"-->
                      <el-select class="form_codition" clearable size="mini"
                        v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)"
                        @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key"
                          :label="item.key" :value="item.value">
                        </el-option>
                      </el-select>
                      <!-- string类型 -->
                      <el-input class="form_codition" @keyup.enter.native="nextFocus(formOneKey)" v-else
                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)"
                        v-model.trim="sendDataInfo[formOneValue.entityField]"
                        :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                  </el-row>
                  <el-row v-if="dataActionBox.actionType == 2">
                    <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                      v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                      <span v-if="formOneValue.isRift == 1">
                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                          sendDataInfo[formOneValue.entityField] }}</a>
                      </span>
                      <span v-else-if="formOneValue.fieldType == 'date'">
                        <span v-if="sendDataInfo[formOneValue.entityField]">
                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                        </span>
                      </span>
                      <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                        sendDataInfo[formOneValue.entityField]
                          == 1 ? "是" : "否" }}</span>
                      <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                        getValue(sendDataInfo[formOneValue.entityField],
                          formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent) }}</span>
                      <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                    </el-form-item>
                  </el-row>
                </el-form>
                <!-- 明细信息 -->
                <div>
                  <el-form :inline="true" size="mini">
                    <el-table size="mini" class="baseTable" v-if="mxForm" ref="mxTableRef"
                      :data="sendDataInfo.detailList" :row-class-name="rowClassName" :row-style="rowStyle"
                      @row-click="clickEvent" @selection-change="handleSelectionChange" border style="width: 100%"
                      :height="mxHeight">
                      <el-table-column align="center" label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                        <template slot-scope="scope">
                          <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                          </el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField"
                        show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                        v-for="(formOneValue, formOneKey) in mxForm.jurconfigform" :key="formOneKey"
                        v-if="formOneValue.isShow == 1">
                        <template slot-scope="scope">
                          <!-- 本次返利金额 -->
                          <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                            @input="calculatePrice(4, scope.$index)" :ref="formOneValue.entityField"
                            v-if="formOneValue.entityField == 'remoney' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                            :maxlength="$store.state.inputLength" type="number"
                            v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                          </el-input>
                          <span v-else-if="formOneValue.isRift == 1">
                            <a @click="toDetail(sendDataInfo.detailList[scope.$index][formOneValue.riftField])">{{
                              sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}</a>
                          </span>
                          <span v-else>{{ sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form>
                </div>
              </div>
            </div>
          </template>
        </v-tabs>
      </el-card>
      <!-- 尾部 -->
      <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
        @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
    </div>
    <!-- 打印 -->
    <printPlan ref="printPlan"></printPlan>
    <!-- 提取 -->
    <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth"
      :modal-append-to-body='true' :append-to-body="true">
      <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth"
        @sendTitle="getExtractName" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import vTabs from "../byComponents/vTabs.vue";
export default {
  name: "puContRebateAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    ExtractionScheme,
    vTabs
  },
  data() {
    //这里存放数据
    return {
      mxHeight: 0,//自适应高度
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "ltr",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      showTabs: "",//tab名称
      formDataList: [],//动态表单数据
      tabForm: [],//动态表单数据---采购合同表单
      mxForm: [],//动态明细数据
      footForm: [],//动态尾部数据
      //新增、修改提交的数据
      sendDataInfo: {},
      detaislDataInfo: {},//明细数据
      selectedDetailsIndex: 0,//明细索引值
      DialogExtract: false,//提取方案弹框
      exId: "",//提取方案Id
      ppId: "conmId",//提取方案---检索条件中获取该字段的值 明细查询id所传的也是该字段的值
      exTitle: "",//提取方案的名称
      exWidth: "",//提取方案的宽度
      fField: "", //焦点字段
      selectedRow: [],// 当前已选择行
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "sendDataInfo.detailList": {
      handler: function (newValue, oldValue) {
        this.sendDataInfo.totalRmoney = 0;
        this.sendDataInfo.totalNumber = 0;
        this.sendDataInfo.totalCount = 0;
        newValue.forEach((item, keys) => {
          for (let key in item) {
            if (item[key] == null || item[key] == 'null') {
              this.sendDataInfo.detailList[keys][key] = ''
            }
          }
          let a = item.num;
          if (item.num == "") {
            item.num = 0;
          } else if (a.length > 1 && a.substring(0, 1) == "0" && a.substring(1, 2) != ".") {
            item.num = a.substring(1, a.length);
          }
          let b = item.psprice;
          if (item.psprice == "") {
            item.psprice = 0;
          } else if (b.length > 1 && b.substring(0, 1) == "0" && b.substring(1, 2) != ".") {
            item.psprice = b.substring(1, b.length);
          }
          if (item.num < 0) {
            this.sendDataInfo["detailList"][keys].num = 0;
            return false;
          }
          if (item.price < 0) {
            this.sendDataInfo["detailList"][keys].price = 0;
            return false;
          }
          if (item.money < 0) {
            this.sendDataInfo["detailList"][keys].money = 0;
            return false;
          }
          if (item.psprice < 0) {
            this.sendDataInfo["detailList"][keys].psprice = 0;
            return false;
          }
          if (item.remoney < 0) {
            this.sendDataInfo["detailList"][keys].remoney = 0;
            return false;
          }
          this.sendDataInfo.totalRmoney = this.$common.getDecimalInfo(
            3,
            NP.plus(this.sendDataInfo.totalRmoney, item.remoney)
          );
          this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
            1,
            NP.plus(this.sendDataInfo.totalNumber, item.num)
          );
        });
        this.sendDataInfo.totalCount = newValue.length;

      },
      deep: true,
    },
    "sendDataInfo.smName": {
      handler: function (newValue, oldValue) {
        if (newValue == '') {
          this.sendDataInfo.smId = ''
          this.sendDataInfo.salesName = "";
          this.sendDataInfo.salesId = "";
        }
      },
      deep: true,
    },
    "sendDataInfo.isPay": {
      handler: function (newValue, oldValue) {
        if (newValue == 0) {
          this.sendDataInfo.sbiName = ''
          this.sendDataInfo.sbiId = ''
          this.sendDataInfo.sbiNumber = ''
          this.tabForm[0].jurconfigform.forEach((item) => {
            if (item.entityField == 'sbiName' || item.entityField == 'sbiNumber') {
              item.isShow = 0
            }
          })
        } else {
          this.tabForm[0].jurconfigform.forEach((item) => {
            if (item.entityField == 'sbiName' || item.entityField == 'sbiNumber') {
              item.isShow = 1
            }
          })
        }
        this.$forceUpdate()
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    getValue(val, type, fieldType, arr) {
      var str = ""
      if (type == 'smIntype') {
        this.dictionariesDatas.forEach(item => {
          if (item.diValue == val) {
            str = item.diName
          }
        })
      } else if (fieldType == 'formatter') {
        if (arr) {
          JSON.parse(arr).forEach(item => {
            if (String(Number(item.value)) != NaN && item.value == val) {
              str = item.key
            } else if (String(Number(item.key)) != NaN && item.key == val) {
              str = item.value
            }
          })
        }
      } else {
        str = val || ""
      }
      return String(str)
    },
    //触发提取
    openExtSearch(id) {
      this.exId = id;//提取方案Id
      this.DialogExtract = true;
    },
    //提取方案获取宽度
    getWidth(e) {
      this.exWidth = e + "%";
    },
    //提取方案获取名称
    getExtractName(e) {
      this.exTitle = e;
    },
    //提取返回
    async getDataByChen(val) {
      if (val != "" || val != undefined) {
        for (let key in val) {
          if (key == "arrlistbychen") {
            this.sendDataInfo.detailList = val.arrlistbychen;
          } else {
            this.sendDataInfo[key] = val[key];
            this.sendDataInfo.totalRmoney = 0
            this.sendDataInfo.totalNumber = 0
            this.sendDataInfo.totalCount = 0
          }
        }
        this.sendDataInfo.detailList.forEach(item => {
          this.sendDataInfo.totalRmoney += item.rrdPsmoney
          this.sendDataInfo.totalNumber += item.oldNum
        })
        this.sendDataInfo.totalCount = this.sendDataInfo.detailList.length
        this.DialogExtract = false;
        this.$nextTick(() => {
          this.selectedDetailsIndex = 0
          let refsElTable = this.$refs.mxTableRef
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this
            .selectedDetailsIndex]);
          this.nextFocus(0)
        })
      }
    },

    //关闭提取、检索方案弹框关闭 创建键盘事件
    closeChild() {
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    // 保存已选择行
    handleSelectionChange(rows) {
      this.selectedRow = rows; // 保存已选择行
    },
    // 明细表格点击选中
    clickEvent(row, column, event, params) {
      let refsElTable = this.$refs.mxTableRef; // 获取表格对象
      let findRow = {};
      this.selectedDetailsIndex = row.rowIndex;
      findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },
    // 表格方法
    rowClassName({
      row,
      rowIndex
    }) {
      let rowName = "",
        findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },
    // 选中行底色逻辑
    rowStyle({
      row,
      rowIndex
    }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
    },
    // 主表单select框切换enter切换焦点事件方法
    selectChange(e) {
      if (e == false) {
        for (let index = 0; index < this.inputel.length; index++) {
          if (this.inputel[index] == document.activeElement) {
            this.nextFocus(index);
            break;
          }
        }
      }
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= this.inputel.length - 1) {
        if (this.sendDataInfo.detailList.length > 0) { }
        return;
      }
      var aindex = index + 1;
      if (this.inputel[aindex].value != "" || this.inputel[aindex].disabled) {
        this.nextFocus(aindex);
        return;
      }
      this.inputel[aindex].focus();
    },
    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == "") {
          this.inputel[index].focus();
          break;
        }
      }
    },
    // 表格切换焦点方法
    tableNextFocus(field, index) {
      if (field == "keydown") {
        if (this.sendDataInfo.detailList[index + 1] != undefined) {
          this.$refs["bgmName"][index + 1].focus();
          return;
        }
        return;
      }
      this.$refs[field][index].focus();
    },
    //打印
    showPrintPlan() {
      // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        console.log("选中的数据", this.actionData);
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },
    //穿透
    toDetail(orderId) {
      this.$parent.$parent.$parent.toDetail(orderId);
    },
    //换行提示
    lineMessageBox(data) {
      let txtArr = data.message.split("<br/>");
      let newArr = [];
      const h = this.$createElement;
      for (const i in txtArr) {
        newArr.push(h("p", null, txtArr[i]));
      }
      this.$alert(h("div", null, newArr), "提示", {
        confirmButtonText: "确定",
        callback: (action) => { },
      });
    },
    // 计算价格
    calculatePrice(cate, index) {
      var info = this.sendDataInfo.detailList[index];
      if (info.remoney <= 0) {
        this.$message({
          message: "请先填写本次返利金额",
          type: "error",
        });
        return false;
      }
      switch (cate) {
        case 4: // 通过本次返利金额计算
          let fl = parseFloat(info.alreadyMoney) + parseFloat(info.remoney)
          let afl = parseFloat(info.buckleMoney)
          if (afl < fl) {
            this.$message({
              message: "本次返利金额+已返利金额不能超过返利金额",
              type: "error",
            });
            this.sendDataInfo.detailList[index].remoney = afl - parseFloat(info.alreadyMoney)
          }
          break;
        default:
          break;
      }
    },
    //关闭窗口
    initActionBox(sendDataInfo) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
      this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel", 0);
          this.init();
        })
        .catch(() => { });
    },
    //初始进入表单动态获取焦点
    changeFocus() {
      setTimeout(() => {
        var el = document.getElementById("mainInfo");
        var inel = el.getElementsByClassName("el-input__inner");
        for (let index = 0; index < inel.length; index++) {
          if (inel[index].value == "") {
            inel[index].focus();
            break;
          }
        }
      }, 500);
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById("mainInfo");
      if (el) this.inputel = el.getElementsByTagName("input");
    },
    //初始化数据
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "pisOrderAuxinf") {
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = "";
          }
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      this.sendDataInfo.detailList = [];
      this.sendDataInfo.totalRmoney = 0;
      this.sendDataInfo.totalNumber = 0;
      this.sendDataInfo.totalCount = 0;
      this.sendDataInfo.orderType = 0; //orderType	订单类型0.药品订单1.器械订单
    },
    // 设置默认值
    initDefaultValue() {
      let arr = this.formDataList[0].jurconfigform
      arr.forEach(item => {
        if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
          this.sendDataInfo[item.entityField] = item.defaultValue
        }
      })
      this.sendDataInfo.isPay = Number(this.sendDataInfo.isPay)
      this.sendDataInfo.psomBuydate = this.$moment().valueOf();
      this.sendDataInfo.psaiDeptime = this.$moment().valueOf();
      this.sendDataInfo.psaiExptime = this.$moment().valueOf();
    },
    openBox() {
      this.$common.routeLog('puContRebateAction')//记录控制台打印页面（前端检查使用）
      this.dataActionBox.actionType = this.actionData.cate;//类型：0新增 1修改 2查看
      this.formDataList = this.actionData.formData;//动态表单
      this.showTabs = this.actionData.formData[0].jciName;//tab标题
      this.filterMainField();
      var oldData = this.actionData.oldData;//数据
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
        this.initDefaultValue()
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {//数据赋值
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
        this.$nextTick(() => {
          this.selectedDetailsIndex = 0;
          setTimeout(() => {
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.detailList[this.selectedDetailsIndex]
            );
          }, 16.7)
        });
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {//数据赋值
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
      }
      //高度适配
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
        }, 100)
        this.changeFocus();
      });
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
          mainFormList.push(item);//动态表单
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item));//动态明细
          this.mxForm.jurconfigform.forEach(item1 => {
            if (item1.fieldType == 'number') {
              this.$set(this.detaislDataInfo, item1.entityField, 0)
            } else if (item1.fieldType == 'search' && item1.setField) {
              var arr = item1.setField.split(',')
              arr.forEach(item2 => {
                this.$set(this.detaislDataInfo, item2, "")
              })
            } else {
              this.$set(this.detaislDataInfo, item1.entityField, "")
            }
          })
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));//动态尾部
        }
      });
      //动态表单
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key));
        this.tabForm[i].jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1 || key.jurconfigform[index].entityField == 'sbiName' || key.jurconfigform[index].entityField == 'sbiNumber')
            this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
        }
      });
      var arr = [{ entityField: "detailList" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {//动态表单实现赋值
        this.$set(this.sendDataInfo, key, obj[key])
      }
    },
    //--------------------------------------------------------
    //保存
    sendDataAction(formName1) {
      let flag = false;
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          this.sub();
        } else {
          this.$message({
            message: "请完善主表单必填信息",
            type: "error",
          });
          flag = true;
          return false;
        }
      });
    },
    //保存调用接口
    async sub() {
      if (this.sendDataInfo.detailList.length < 1) {
        this.$message({
          message: "请添加明细",
          type: "error",
        });
        return;
      } else {
        this.sendDataInfo.detailList.forEach((item, index) => {
          if (item.bgmId == "") {
            this.sendDataInfo.detailList.splice(index, 1);
          }
        });
      }
      this.sendDataInfo.totalCount=this.sendDataInfo.detailList.length
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.conrebateAdd(this.sendDataInfo);
      } else {
        var responseData = await this.$http.conrebateUpdate(this.sendDataInfo);
      }
      if (responseData.status == 200) {
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel", 1);
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 监听键盘事件
    keyUp(e) {
      if (e.keyCode == 40) {
        // 下键
        // 表格为空，不执行下方
        if (this.sendDataInfo.detailList.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 如果当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (
            this.selectedDetailsIndex ==
            this.sendDataInfo.detailList.length - 1
          ) {
            // 如果选中的是最后一行了，那么下一行选中的是第一行
            this.selectedDetailsIndex = 0;
          } else {
            // 正常递增
            this.selectedDetailsIndex++;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.detailList[this.selectedDetailsIndex],
              false
            );
            return;
          }
          this.tableNextFocus("bgmName", this.selectedDetailsIndex);
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.detailList[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      } else if (e.keyCode == 38) {
        // 上键
        if (this.sendDataInfo.detailList.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (this.selectedDetailsIndex == 0) {
            // 如果选中的是第一行了，那么下一行选中的是最后一行
            this.selectedDetailsIndex =
              this.sendDataInfo.detailList.length - 1;
          } else {
            // 正常递减
            this.selectedDetailsIndex--;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.detailList[this.selectedDetailsIndex],
              false
            );
            return;
          }
          this.tableNextFocus("bgmName", this.selectedDetailsIndex);
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.detailList[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // addEventListener('keydown', this.keyDown)
    addEventListener("keyup", this.keyUp); //创建监听键盘事件
  },
  beforeDestroy() {
    removeEventListener("keyup", this.keyUp);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput();
  }, //生命周期 - 更新之后
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.v-modal {
  position: static !important;
  width: 100%;
  height: 100%;
  background: transparent;
}

::v-deep .el-alert__content {
  width: 100%;
}
</style>